var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'turnovertype-edit',
  created () {
    this.search()
  },
  data () {
    return {
      canValidate: true,
      turnover: {
        turnover_class: null,
        turnover_content: null,
      }
    }
  },
  computed: {
    turnovertypes () {
      return this.$store.getters.turnover
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    validation: function() {
      var v = {
        turnover_class: !!this.turnovertypes.data.attributes['turnover-class'],
        turnover_content: !!this.turnovertypes.data.attributes['turnover-content'],
        not_input: !!this.turnovertypes.data.attributes['turnover-class'] && !!this.turnovertypes.data.attributes['turnover-content']
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },  
  methods: {
    onClickSave: function () {
      this.canValidate = true
      if (this.isValid) {
        console.log("is valid")
        var data = {
          turnover_class: this.turnovertypes.data.attributes['turnover-class'],
          turnover_content: this.turnovertypes.data.attributes['turnover-content']
        }
        this.$store.dispatch('TURNOVER_UPDATE', { id: this.$route.params.id, data: data, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/turnover_types', query: { type: this.$router.currentRoute.query.type}})
    },
    search: function() {
      var data = {}
      var self = this
      data.callback = function () {
      }
      this.$store.dispatch('TURNOVER_EDIT',  {id: this.$route.params.id, data: data})
    },
    half: function () {
      this.turnovertypes.data.attributes['turnover-content'] = utils.emHalf(this.turnovertypes.data.attributes['turnover-content'])
    },
    onSaved: function (result) {
      this.$router.push({ path: '/turnover_types/'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/turnovertype-edit.js